import { IWorkBenchLayout } from '@fox/blocks/contracts/work-bench';
import { PAYMENT_BLOCK_ANSWER_TYPE, TICKET_BLOCK_TYPE, TRANSACTION_BLOCK_TYPE } from '../../../../form-block-types';
import { FormEventAPIHelpers } from '../../../form-event-context/form-event-context';
import { IField, IQuestionAnswer } from '../../../form-root/contracts';
import { ISection } from '../../section-block/contracts';
import { validatePaymentBlock } from './validate-payment-block';
import { validateTicketBlock } from './validate-ticket-block';
import { validateTransactionBlock } from './validate-transaction-block';

//export const PAYMENT_BLOCK_ANSWER_TYPE = 'Card Payment'; // If you try import this from card-payment-block it doesn't error but is undefined, this file is weird

export const FORM_PAGE_VALIDATORS: Record<string, FormPageValidatorFunctionType> = {
	[PAYMENT_BLOCK_ANSWER_TYPE]: validatePaymentBlock,
	[TRANSACTION_BLOCK_TYPE]: validateTransactionBlock,
	[TICKET_BLOCK_TYPE]: validateTicketBlock
};
export type FormPageValidatorFunctionType = (props: FormPageValidatorFunctionProps) => Promise<FormPageValidatorFunctionResult>;
export type FormPageValidatorFunctionResult = { success: boolean; errorMessage?: string };
export type FormPageValidatorFunctionProps = {
	formRequestId: string;
	field: IField;
	sections: ISection[];
	tempData: Record<string, any> | undefined;
	answers: IQuestionAnswer[];
	isFinalPage: boolean;
	ownerId: string | undefined;
	formEventApiHelpers: Pick<FormEventAPIHelpers, 'createTicketReservation' | 'extendReservation' | 'findReservationById' | 'getTicketDetails'>;
	layout?: IWorkBenchLayout;
	onWaitList?: boolean;
};
